import React, { useEffect, useState } from 'react';
import Item from '../Item/Item';
import './videos.css';

const Videos = () => {

    const[loadVideos, setLoadVideos] = useState([]);
    const[loads, setLoads] = useState(10);
    useEffect(()=>{
    fetch('https://youtube.googleapis.com/youtube/v3/search?part=snippet&channelId=UC49igY3A_M9__UL4_QUWTBA&order=date&maxResults=150&key=AIzaSyBaQ3qRfrim14hAzutqHtPUR-Oq-_jhNSg')
    // 1// AIzaSyDmkbaou-jKuJGu3L-HejODBLbeHptulzI
    // 2// AIzaSyBaQ3qRfrim14hAzutqHtPUR-Oq-_jhNSg
    .then(res => res.json())
    .then(data => setLoadVideos(data?.items))
    },[])

    // console.log(loadVideos);
    const loadMore = (loads) =>{
        let newLoad = loads + 30;
        loads = newLoad;
        setLoads(loads)
    }

    return (
        <div>
            <h1 className=' flex md:inset-y-40 text-black justify-center font-bold text-2xl md:text-5xl italic mt-20 mb-3'>All Videos</h1>
            <div className='videos'>
            {
                loadVideos?.slice(0, loads).map(vdo => <Item key={vdo.id.videoId} vdo={vdo}></Item>)
            }
            </div>
            <div className='my-5 mx-auto w-40'>
                <button onClick={()=>loadMore(loads)} className="btn btn-primary">Load more</button>
            </div>
        </div>
    );
};

export default Videos;